"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboxStatus = exports.InboxDistributionStatus = exports.InboxType = void 0;
exports.InboxType = {
    Distribution: "distribution", // 振り分け
};
exports.InboxDistributionStatus = {
    DistributionRequired: "distributionRequired",
    RobotaLoading: "robotaLoading",
    RobotaLoaded: "robotaLoaded",
};
exports.InboxStatus = exports.InboxDistributionStatus; // 今後振分以外でデジタル受信箱を使う場合に項目が増える？？
